import { Validators } from '@angular/forms';
import type {
  PathKind,
  SchemaPath,
  SchemaPathRules,
} from '@angular/forms/signals';
import { maxLength } from '@angular/forms/signals';

const ONYX_TEXT_FIELD_MAX_LENGTH = 255;

export const onyxTextFieldLengthValidator = Validators.maxLength(
  ONYX_TEXT_FIELD_MAX_LENGTH,
);

export const onyxTextFieldLength = <TPathKind extends PathKind = PathKind.Root>(
  schemaPath: SchemaPath<string, SchemaPathRules.Supported, TPathKind>,
): void => maxLength(schemaPath, ONYX_TEXT_FIELD_MAX_LENGTH);
